import {
  FETCH_ALERT_LEVEL,
  FETCH_ALERT_LEVELS_FAIL,
  FETCH_ALERT_LEVELS_SUCCESS,
  FETCH_WORKFLOW_STATUS_LIST,
  FETCH_WORKFLOW_STATUS_LIST_SUCCESS,
  FETCH_WORKFLOW_STATUS_LIST_FAIL,
  UPDATE_ALERT_LEVEL,
  UPDATE_ALERT_LEVEL_SUCCESS,
  UPDATE_ALERT_LEVEL_FAIL,
  UPDATE_WORKFLOW_STATUS_LIST,
  UPDATE_WORKFLOW_STATUS_LIST_SUCCESS,
  UPDATE_WORKFLOW_STATUS_LIST_FAIL
} from '../../actions/cm/workFlowStatus';

export const initialState = {
  isLoading: false,
  hasError: false,
  workFlowStatusList: [],
  alertLevels: [],
  errorMessage: ''
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_ALERT_LEVEL:
    case FETCH_WORKFLOW_STATUS_LIST:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_WORKFLOW_STATUS_LIST_SUCCESS:
      return {
        ...state,
        workFlowStatusList: payload,
        isLoading: false
      };
    case FETCH_ALERT_LEVELS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        alertLevels: payload
      };
    case FETCH_ALERT_LEVELS_FAIL:
    case FETCH_WORKFLOW_STATUS_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case UPDATE_WORKFLOW_STATUS_LIST:
    case UPDATE_ALERT_LEVEL:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case UPDATE_ALERT_LEVEL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false
      };
    case UPDATE_WORKFLOW_STATUS_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false
      };
    case UPDATE_WORKFLOW_STATUS_LIST_FAIL:
    case UPDATE_ALERT_LEVEL_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    default:
      return state;
  }
}
